import React from 'react';

const PaymentSummarySpan = ({
  title,
  value,
  isHighlighted,
}: {
  title: string,
  value: string | number,
  isHighlighted?: boolean,
}) =>
  value ? (
    <li>
      <span>{title}: </span>
      <span className={isHighlighted ? 'price-hi' : ''}>{value}</span>
    </li>
  ) : null;

export default PaymentSummarySpan;



// WEBPACK FOOTER //
// ./src/components/PaymentSummarySpan/PaymentSummarySpan.js